/**
 * The Brew wordmark's box.
 *
 * On a motion-enabled load `BrewAnimatedLogo` paints three different elements
 * in sequence — the static `<Image>`, `next/dynamic`'s loading fallback, then
 * the Rive canvas — inside the hero heading row, where anything that changes
 * size moves the composer and the whole page below it. One wrapper owns the
 * box and every variant fills it, so that sequence is a repaint and never a
 * reflow. Before this, the `loading` fallback hardcoded its own `h-10 w-28`
 * and dropped the caller's `md:` override, so the row went 64 → 40 → 64px.
 *
 * The caller's className merges onto the WRAPPER. That is what lets
 * `md:h-16 md:w-36` (hero) and `h-10 w-28` (onboarding) both work through
 * tailwind-merge while no variant can override or discard either.
 */
export const BREW_LOGO_BOX_CLASSNAME = '-mb-[2px] block h-12 w-30 shrink-0'

export const BREW_LOGO_FILL_CLASSNAME = 'block h-full w-full dark:invert'
